import './agentForm.scss';
import AgentIcon from '../../../icons/agent.svg';
import AgentDownloadIcon from '../../../icons/agent-download.png';
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import _ from 'underscore';
import generateInstallerLink from '../../../js/serverApi/installerLinkGenerator';
import serverApi from '../../../js/serverApi';
import FormErrorNotification from '../FormErrorNotification';
import LoaderWithText from '../LoaderWithText';

export default (formName, validate) => {
    const AgentForm = React.createClass({
        getInitialState: function() {
            return {
                isDownloading: true,
                installerLink: generateInstallerLink(),
                initiallyRegisteredAgentIds: this.props.agents.map(x => (x.id)),
                newlyRegisteredAgents: []
            };
        },
        propTypes: {
            onValid: PropTypes.func.isRequired,
            onCancel: PropTypes.func.isRequired,
            agents: PropTypes.array.isRequired
        },
        selectAgent: function(selectedAgent) {
            this.props.onValid(selectedAgent);
        },
        componentDidMount: function() {
            window.setTimeout(() => {
                serverApi.downloadInstaller();
                this.setState({ isDownloading: false });
            }, 1000);
        },
        componentWillReceiveProps: function(nextProps) {
            const { initiallyRegisteredAgentIds } = this.state;
            const newlyRegisteredAgents = _(nextProps.agents).filter(x => (!_(initiallyRegisteredAgentIds).contains(x.id)));
            this.setState({ newlyRegisteredAgents: newlyRegisteredAgents });
        },
        render: function() {
            const { submitting, error, onCancel } = this.props;
            const { isDownloading, installerLink, newlyRegisteredAgents } = this.state;
            const hasNewlyRegisteredAgents = newlyRegisteredAgents.length > 0;

            return <div className="downloading-agent">
                <div>                    
                    <FormErrorNotification error={error} />

                    <h2>Install new agent</h2>
                    <p>You'll need to download a new installer for each machine that hosts a SQL Server instance you wish to create an image from or clone to.</p>

                    {isDownloading && <div className="control-holder">
                        The agent download will start shortly...
                    </div>}

                    {!isDownloading && <div className="control-holder downloading-agent-message">
                        <div className="message-icon">
                            <img alt="agent-is-downloading" src={AgentDownloadIcon} />
                        </div>

                        <div className="message-title">A single-use agent installer is downloading</div>

                        <div className="message-desc"> 
                            If the download didn't start, click <a href={installerLink} target="_blank">this link</a> to start it manually.
                        </div>
                    </div>}

                    {!isDownloading && !hasNewlyRegisteredAgents && <div className="control-holder looking-for-agent-container">
                        <LoaderWithText loadingText="Waiting for you to install the agent" />    
                    </div>}

                    {!isDownloading && hasNewlyRegisteredAgents && <div className="control-holder installed-agent">
                        {newlyRegisteredAgents.map(agent => <div key={agent.id} className="installed-agent-selector">
                            <div className="icon-holder"><img src={AgentIcon} alt="agent-icon" /></div>
                            <div className="name-holder">{agent.machineName}</div>
                            <div className="select-btn-holder">
                                <button className="nobutton button--flat-secondary" onClick={() => this.selectAgent(agent)}>
                                    Select
                                </button>
                            </div>
                        </div>)}
                    </div>}

                    <div className="button-holder">
                        <button className="nobutton button--flat-secondary" disabled={submitting} onClick={onCancel}>
                            Cancel
                        </button>
                    </div>
                </div>
            </div>;
        }
    });

    const mapStateToProps = (state) => {
        return {
            agents: Array.from(state.agents.value.values()).map(a => {
                return {
                    id: a.id,
                    machineName: a.machineName
                };
            })
        };
    };

    return connect(mapStateToProps)(
        reduxForm({ form: formName, validate })(AgentForm)
    );
};


// WEBPACK FOOTER //
// ./src/components/common/AgentSelection/AgentForm.jsx